const authorisation = async ({ getAuthorisation }) => ({
  Authorization: await getAuthorisation({ timeoutMs: 8000, retries: 0 })
});

export default authorisation;
